import { createFileRoute } from '@tanstack/react-router';
import { checkSecurityDomain } from '../../../utils/auth';

export const Route = createFileRoute('/team-insights/sessions/monthly/$year/$month')({
  beforeLoad: checkSecurityDomain({
    routeObject: 'analytics',
  }),
});
